import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="menu-item"
export default class extends Controller {
  static targets = ["li", "button"];

  connect() {
    this.item_opened = false;
    this.closeTimeout = null;

    if (document.body.clientWidth >= 1280) {
      return;
    }

    if (this.element.classList.contains("active")) {
      $(this.element).parents("li").each((i, element) => {
        $(element).addClass("open");
      });
    }
  }

  toggle() {
    this.item_opened = !this.item_opened;
    this.element.classList.toggle("open");
    this.item_opened = !this.item_opened;
  }

  showModal(e) {
    if (document.body.clientWidth < 1280) {
      return;
    }

    // Clear any pending close
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    if (this.element.parentElement.classList.contains("main")) {
      // Close only sibling menu items, not all menus (prevents flicker)
      this.element.parentElement.querySelectorAll(":scope > li.open").forEach((item) => {
        if (item !== this.element) {
          item.classList.remove("open");
        }
      });
      this.element.classList.add("open");
    }
  }

  closeModal(e) {
    if (document.body.clientWidth < 1280) {
      return;
    }

    // Add delay before closing to allow cursor to move to dropdown
    this.closeTimeout = setTimeout(() => {
      if (this.element.parentElement.classList.contains("main")) {
        window.dispatchEvent(new CustomEvent("closeMenu"));
        this.element.classList.remove("open");
      }
    }, 100);
  }

  closeOnClick(e) {
    // Only close on desktop, let toggle work on mobile
    if (document.body.clientWidth < 1280) {
      return;
    }

    // Close the menu when clicking on a link
    this.element.classList.remove("open");
    // Also close any parent menu items
    this.element.closest("ul.main")?.querySelectorAll(".open").forEach((item) => {
      item.classList.remove("open");
    });
  }
}
